import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    items: [],
    slugs: [],
    currentStep: 1,
    currentStepSub: 0,
    currentStepSubimage: 0,
  },
  mutations: {
    SET_ITEMS(state, items) {
      // eslint-disable-next-line no-param-reassign
      state.items = Object.entries(items);
      // eslint-disable-next-line no-param-reassign
      for (let index = 0; index < state.items.length; index += 1) {
        const element = state.items[index][1].slug;
        // eslint-disable-next-line no-param-reassign
        state.slugs.push(element);
      }
    },
    decrement(state) {
      if (state.currentStep >= 2) {
        // eslint-disable-next-line no-plusplus, no-param-reassign
        state.currentStep--;
        setTimeout(() => {
          // eslint-disable-next-line no-plusplus, no-param-reassign
          state.currentStepSub = 0;
          // eslint-disable-next-line no-plusplus, no-param-reassign
          state.currentStepSubimage = 0;
        }, 500);
      }
    },
    increment(state) {
      if (state.currentStep < state.items.length) {
        // eslint-disable-next-line no-plusplus, no-param-reassign
        state.currentStep++;
        setTimeout(() => {
          // eslint-disable-next-line no-plusplus, no-param-reassign
          state.currentStepSub = 0;
          // eslint-disable-next-line no-plusplus, no-param-reassign
          state.currentStepSubimage = 0;
        }, 500);
      }
    },
    decrementSub(state) {
      if (state.currentStepSub >= 1) {
        // eslint-disable-next-line no-plusplus, no-param-reassign
        state.currentStepSub--;
      }
    },
    incrementSub(state) {
      if (state.currentStepSub < state.items[(state.currentStep - 1)][1].szoveg.length - 1) {
        // eslint-disable-next-line no-plusplus, no-param-reassign
        state.currentStepSub++;
      }
    },
    decrementSubImage(state) {
      if (state.currentStepSubimage >= 1) {
        // eslint-disable-next-line no-plusplus, no-param-reassign
        state.currentStepSubimage--;
      }
    },
    incrementSubImage(state) {
      if (state.currentStepSubimage < state.items[(state.currentStep - 1)][1].image.length - 1) {
        // eslint-disable-next-line no-plusplus, no-param-reassign
        state.currentStepSubimage++;
      }
    },
  },
  actions: {
    loadItems({ commit }) {
      axios
        .get('./list.json')
        .then(response => response.data)
        .then((items) => {
          commit('SET_ITEMS', items);
        });
    },
    decrement: ({ commit }) => commit('decrement'),
    increment: ({ commit }) => commit('increment'),
    decrementSub: ({ commit }) => commit('decrementSub'),
    incrementSub: ({ commit }) => commit('incrementSub'),
    decrementSubImage: ({ commit }) => commit('decrementSubImage'),
    incrementSubImage: ({ commit }) => commit('incrementSubImage'),
  },
});
